module.exports = __webpack_public_path__ + "img/btn-swiper-prev.d9ee16de.svg";